import React from 'react';
import { pdf, Font, Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import cl from './Contract.module.css'
import PDFicon from "../../../../assets/Icon/Contract";
import HelveticaBold from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-75Bd.ttf'; 
import HelveticaRd from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-55Rm.ttf';  
import { baseFileURL } from '../../../../Api';
import { useTranslation } from 'react-i18next';

const formatDate = (dateString, t) => {
    const purchasedAtDate = new Date(dateString);
    const months = [
        t('Jan'), t('Feb'), t('Mar'), t('Apr'), t('May'), t('Jun'),
        t('Jul'), t('Aug'), t('Sep'), t('Oct'), t('Nov'), t('Dec')
    ];
     
    const day = purchasedAtDate.getDate();
    const month = months[purchasedAtDate.getMonth()];
    const year = purchasedAtDate.getFullYear();

    return `${day} ${month} ${year}`;
};

const shouldShowMarketingConsentClause = (purchased_at) => {
    console.log('purchased_at in condition:', purchased_at);

    if (!purchased_at) return false;

    const purchasedAtDate = new Date(purchased_at);
    const startDate = new Date('2026-04-22T00:00:00');

    console.log('parsed:', purchasedAtDate, 'valid:', !Number.isNaN(purchasedAtDate.getTime()));
    console.log('show clause:', purchasedAtDate > startDate);

    if (Number.isNaN(purchasedAtDate.getTime())) return false;

    return purchasedAtDate > startDate;
};



let primaryColor = "#000"
let ltd = "___________________"
let sk = "___________________"
let email = "___________________"
let tel = "_____________" 
let BOGbankAccount = "___________________"
let TBCbankAccountGel = "___________________"
let TBCbankAccountUSD = "___________________"
let address = "___________________"
let director_position = "___________________"
let director = "___________________"
let director_pn = "___________________"
let danarti = "___________________"

if(baseFileURL === 'https://finance.automoby.ge') {
    primaryColor = "#235e82"
    ltd = "შ.პ.ს. „ავტომობი“"
    sk = "446977022" 
    email = "info@automoby.ge" 
    tel = "(+995) 591 24 60 60; 0322 11 55 22 " 
    address = "დ.აღმაშენებლის 154, თბილისი " 
    BOGbankAccount = "GE74BG0000000533900476"
    TBCbankAccountGel = "___________________"
    TBCbankAccountUSD = "___________________"
    director_position = "დირექტორი"
    director = "ნინო ჩანადირი"
    director_pn = "01024069247"
    danarti = "https://automoby.ge/danarti.pdf"

} else if(baseFileURL === 'https://crm.aig.com.ge') {

    primaryColor = "#da0429" 
    ltd = "შ.პ.ს. „ავტო იმპორტ ჯორჯია“"
    sk = "406203120"
    email = "info@aig.com.ge" 
    tel = "(+995) 591 24 60 60; 0322 11 12 13" 
    address = "გიორგი სააკაძის მე-2 შესახვევი ატრიუმის ბიზნესცენტრი, 1-ლი სართული თბილისი, 0160, საქართველო" 
    BOGbankAccount = "GE19BG0000000131217994"
    TBCbankAccountGel = "GE54TB7734536020100004"
    TBCbankAccountUSD = "GE17TB7734536120100007"
    director_position = "ადმინისტრაციული დეპარტამენტის ხელმძღვანელი"
    director = "მარიამ აქულაშვილი"
    director_pn = "01011091639"
    danarti = "https://autoimport.com.ge/wp-content/uploads/2019/10/Auto-aukcioni-A-mnishvn-pirobebi-21-05-19-2.pdf"
}

Font.register({
    family: 'HelveticaRd',  
    src: HelveticaRd, 
});

Font.register({
    family: 'HelveticaBold', 
    src: HelveticaBold, 
});



const styles = StyleSheet.create({

    page: {
        fontFamily: 'HelveticaRd', 
        backgroundColor: '#FFF',
        padding: '40px 50px',
        fontSize: '10px',
        lineHeight: 1.5, 
        textAlign: 'justify',
    }, 
    
    p: { 
        marginBottom: '10px',
        textAlign: 'justify',
    }, 
    p0: { 
        marginBottom: '0px',
        textAlign: 'justify',
    }, 
    b: { 
        fontFamily: 'HelveticaBold', 
    }, 

});

 


const MyDocument = ({ car, t }) => (
    <Document>

        <Page size="A4" style={styles.page}>
            <Text style={{ fontFamily: 'HelveticaBold', textAlign: 'center', marginBottom: '10px' }}>
                თანხმობა ინფორმაციის გადაცემაზე
            </Text>

            <Text style={{  textAlign: 'right', marginBottom: '10px' }}>
               {formatDate(car.purchased_at, t)}
            </Text>

            <Text style={styles.p}>
                მე, {car.client.firstname} {car.client.lastname} პირადი № {car.client.personal}, ვადასტურებ, რომ მსურს ავტომობილის შეძენა შპს „ავტო იმპორტ ჯორჯია“-სგან (ს/კ: 406203120, შემდგომში „კომპანია“) და ავტომობილის შეძენის მიზნით საბანკო კრედიტის ან/და სხვა საბანკო პროდუქტის მისაღებად მივმართე კომპანიის პარტნიორ ბანკს სს „პროკრედიტ ბანკს“ (ს/ნ: 204851197, შემდგომში „ბანკი“).
            </Text>

            <Text style={styles.p}>
                ვაცხადებ თანხმობას, რომ ბანკმა კომპანიას გადასცეს ინფორმაცია ჩემთვის საბანკო კრედიტის ან/და სხვა საბანკო პროდუქტის დამტკიცების ან/და გაცემის შესახებ, მათ შორის ინფორმაცია დამტკიცებული თანხის, კრედიტის/საბანკო პროდუქტის ძირითადი პირობების და სტატუსის შესახებ.
            </Text>

            <Text style={styles.p}>
                აღნიშნული ინფორმაცია გადაეცემა მხოლოდ ავტომობილის შეძენის პროცესის ორგანიზების, ხელშეწყობისა და შესაბამისი მომსახურების გაწევის მიზნით და მხოლოდ ამ მიზნისთვის აუცილებელი მოცულობით..
            </Text>

            <Text style={styles.p}>
                ვადასტურებ, რომ წინამდებარე თანხმობა არის ინფორმირებული, რომელიც გავეცი ნებაყოფლობით, ჩემი თავისუფალი ნების საფუძველზე.
            </Text>

            <Text style={styles.p}>
                წინამდებარე თანხმობა მოქმედებს მის გამოხმობამდე, გარდა იმ შემთხვევევისა, როდესაც მონაცემთა დამუშავება კანონით სხვა სამართლებრივ საფუძველს ემყარება ან/და კანონით სხვა რამ არ არის გათვალისწინებული.
            </Text>

            <Text style={{ marginTop: '30px' }}>
                მომხმარებელი: {car.client.firstname} {car.client.lastname}
            </Text>

            <Text style={{ marginTop: '30px' }}>
                ხელმოწერა: ___________________________  
            </Text>

        </Page>


    </Document>
);

const Leasing = ({ carItem }) => {
    const {t} = useTranslation();
  
    const generatePDF = async () => {
        const blob = await pdf(<MyDocument t={t} car={carItem} />).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank'; 
        link.click();
    };

    return (
        <span className={cl.btn} onClick={generatePDF}> <PDFicon /> {t('ლიზინგი')} </span>
    );
};

export default Leasing;
